import { c as _c } from "react/compiler-runtime";
import { BOOKING_EXPERIENCE_ID, BOOKING_VOUCHER_EXPERIENCE_ID } from '@/constants/config';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import buildExperienceHref from '@/utils/routes/buildExperienceHref';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import { useNavigate } from 'react-router-dom';
import useTunnelExperience from '../../../context/hooks/useTunnelExperience';
import Step from './Step';
const NO_EXPERIENCE_LINK = BOOKING_VOUCHER_EXPERIENCE_ID || BOOKING_EXPERIENCE_ID;
const ExperienceStep = () => {
    const $ = _c(12);
    const navigate = useNavigate();
    const translate = useTranslate();
    const { experienceId, experience } = useTunnelExperience();
    let t0;
    if ($[0] !== experience?.type || $[1] !== translate) {
        t0 = experience?.type ?
            capitalize(translate(`experience.type.${experience?.type}`, { count: 1 })) :
            capitalize(translate("messages.experience"));
        $[0] = experience?.type;
        $[1] = translate;
        $[2] = t0;
    }
    else {
        t0 = $[2];
    }
    const label = t0;
    let t1;
    if ($[3] !== experience?.type || $[4] !== experienceId) {
        t1 = !NO_EXPERIENCE_LINK && experience?.type && experienceId ?
            buildExperienceHref(experienceId) : null;
        $[3] = experience?.type;
        $[4] = experienceId;
        $[5] = t1;
    }
    else {
        t1 = $[5];
    }
    const href = t1;
    let t2;
    if ($[6] !== href || $[7] !== navigate) {
        t2 = href ? () => {
            navigate(href);
        } : undefined;
        $[6] = href;
        $[7] = navigate;
        $[8] = t2;
    }
    else {
        t2 = $[8];
    }
    const handleClick = t2;
    let t3;
    if ($[9] !== handleClick || $[10] !== label) {
        t3 = <Step number={1} onClick={handleClick} isDone={true}>
      {label}
    </Step>;
        $[9] = handleClick;
        $[10] = label;
        $[11] = t3;
    }
    else {
        t3 = $[11];
    }
    return t3;
};
export default ExperienceStep;
